module.exports = __webpack_public_path__ + "media/18.6ad94344.mp3";